import { FC } from 'react'
import { PaymentMethod } from '../models';
import { KTSVG } from '../../../helpers/KTSVG';
import { GenericDropdown } from '../../../hooks/utils/GenericDropdown';

interface Props {
  card: PaymentMethod
  onEdit: (id: number) => void
  onDelete: (id: string) => void
}

export const CardPayment: FC<Props> = ({ card, onEdit, onDelete }) => {
  return (
    <div className={`payments-method-card ${card?.primary ? 'payments-method-card--primary' : ''}`}>
      <div className="payments-method-card__left">
        <div className="payments-method-card__icon tap-flex-center">
          <KTSVG path='/media/svg/nobilis/bank.svg' />
        </div>
        <div className="payments-method-card__content">
          <span className="payments-method-card__title text-uppercase">{card?.brand} ****{card?.last4}</span>
          <span className="payments-method-card__meta">
            <span className="payments-method-muted">Expiration</span> : {card?.expMonth && card?.expYear ? `${card?.expMonth}/${card?.expYear}` : ''}
          </span>
        </div>
      </div>

      <div className="payments-method-card__right">
        <GenericDropdown
          options={[
            // { id: 1, label: 'Edit', onClick: () => { onEdit?.(Number(card.id)) } },
            { id: 1, label: 'Delete', onClick: () => { onDelete?.(card.id) } },
          ]}
          placeholder="⋅⋅⋅"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.id}
        />
        {card?.primary && <span className="text-card-primary">Primary</span>}
      </div>
    </div>
  );
}
